<template>
  <div :class="classes">
      <pt-page-title :title="title" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
          <template slot="before-left" v-if="!hideBtn">
              <el-button type="primary" @click="createCustomer">新建客户</el-button>
          </template>
      </pt-page-title>
      <pt-customer-table :tableLabels="tableLabels" :class="$style['pt-system-customer-table']" ref="table" :paramsData="paramsData" :isFromRouter="isFromRouter" :showRadio="showRadio" @updateSelectData="updateSelectData" :selectedKeys="selectedKeys">
          <el-table-column label="操作" slot="default">
            <div slot-scope="scope" :class="$style['opreation-button']">
              <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
              <el-button v-if="canEdit" type="text" @click="editCustomer(scope.row)">编辑</el-button>
            </div>
        </el-table-column>
      </pt-customer-table>
  </div>
</template>

<script>
// 组件class前缀
import { customerTableLabels } from './options'
import ptCustomerTable from './pt-customer-table/withData'
import {
  emptyObject
} from '@/utils/lifebankUtils'
const prefixCls = 'pt-customer-manage'
export default {
  name: 'pt-customer-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tenant () {
      return this.$store.state.saasConfig.tenant
    },
    tableLabels () {
      return customerTableLabels
    }
  },
  components: {
    ptCustomerTable
  },
  props:{
    title:{
      type:String,
      default:'客户管理'
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: '',
      selectId:'',
      select_row:{}
    }
  },
  methods: {
    updateSelectData (data) {
      this.$emit('updateSelectData', data)
    },
    search (val) {
      this.searchKey = val
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.$set(this.params, 'searchKey', val)
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch (val) {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = { ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    },
    editCustomer (val) {
      this.$router.push('/customer-manage/customer-form/true/' + val.id)
    },
    
    goDetail (row) {
      this.$router.push(`/customer-detail/${row.id}`)
    },
    createCustomer () {
      this.$router.push('/customer-manage/customer-form/false/0')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    :global
    .iconfont{
        margin-right: 10px;
    }
}
</style>
